import { render, staticRenderFns } from "./vouch.vue?vue&type=template&id=52eff751&scoped=true&"
import script from "./vouch.vue?vue&type=script&lang=js&"
export * from "./vouch.vue?vue&type=script&lang=js&"
import style0 from "./vouch.vue?vue&type=style&index=0&id=52eff751&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eff751",
  null
  
)

export default component.exports